import { PATHS } from '@/config/paths';

export const authRoutes = [
  PATHS.auth.login,
  PATHS.auth.otp,
  PATHS.auth.resetPassword,
];

export const profileRoutes = [PATHS.profile.register, PATHS.profile.updateData];

export const floatingInvestScreensRoutes = [
  PATHS.consolidator.comparator,
  PATHS.consolidator.index,
  PATHS.hubs.recommendation,
];

export const monetaryButtonHeaderScreensRoutes = [
  PATHS.consolidator.index,
  PATHS.financialPlanning.index,
  PATHS.financialPlanning.myGoals,
  PATHS.financialPlanning.immobilized,
  PATHS.financialPlanning.myWealth,
  PATHS.financialPlanning.financialControl,
  PATHS.financialPlanning.report,
  PATHS.lp.riCalculatorSimulation,
  PATHS.hubs.finances,
];

export const routesDoNotSendVisit = [
  PATHS.home,
  PATHS.hubs.content,
  '/ativo/chart',
];

export const routesSHowDisclaimerEqiResearchHubs = [
  PATHS.hubs.recommendation,
  PATHS.hubs.research,
];
export const routesShowDisclaimerWebMobile = [
  ...authRoutes,
  PATHS.custom.index,
  PATHS.embed.retirementChart,
];

export const publicRoutes = [
  PATHS.event.index,
  PATHS.hubs.author,
  PATHS.hubs.content,
  PATHS.hubs.program,
  PATHS.hubs.research,
  PATHS.hubs.researchProgram,
  PATHS.news.index,
  PATHS.auth.magicLink,
  PATHS.embed.retirementChart,
  PATHS.hubs.privatePension,
  PATHS.lp.riCalculator,
  PATHS.lp.riCalculatorSimulation,
];
